import { render, staticRenderFns } from "./GridSocialIconsProviderUser.vue?vue&type=template&id=9a6ca552&"
import script from "./GridSocialIconsProviderUser.vue?vue&type=script&lang=js&"
export * from "./GridSocialIconsProviderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports